import { TableRow, styled } from "@mui/material";

/**
 * Styled MUI TableRow which removes the border from the last item in a table.
 */
export const AkiTableRow = styled(TableRow)({
  "&:last-child td, &:last-child th": { border: 0 },
  "&.MuiTableRow-hover": { cursor: "pointer" },
});
